import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_asimov.png",
      alt: "Estratégias Asimov",
    },
    title: "Daytrade com Inteligência Artificial",

    // String ou array de strings
    text: [
      "O mercado financeiro atual se resume, em grande parte, a uma série de algoritmos automatizados gerindo uma enorme quantidade de capital. Visto isso, os robôs Asimov foram desenvolvidos aplicando todo o conhecimento adquirido em Redes Neurais Artificiais, trazendo trades muito mais assertivos e uma gestão de risco sem dores de cabeça.",
    ],
    testimonial: {
      text: "Total transparência e inovação tecnológica de ponta aplicada ao mercado financeiro.",
      author: {
        name: "Thiago Barreto, estrategista Asimov.",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias com Machine Learning",
    heading: "Operações criteriosas e conservadoras",
    subtitle:
      "Todas as 8 estratégias foram desenvolvidas utilizando técnicas avançadas de inteligência artificial que vão se adaptando às mudanças do mercado.",
  },

  cta: {
    title: "Vai ficar de fora? Restam POUCAS VAGAS.",
    subtitle: "Ative AGORA mesmo a extensão ASIMOV.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Asimov",
    col1: [
      "A Asimov é uma empresa fundada pelo Data Scientist Thiago Barreto, que fornece estratégias automatizadas para o mercado financeiro utilizando técnicas de aprendizado de máquina (machine learning). Barreto acumula uma bagagem de +15 anos de experiência entre empresas multinacionais, instituições de pesquisa e já auxiliou +1000 traders a alcançarem ganhos consistentes na bolsa de valores.",
    ],
    // col2: [
    // ],
  },

  stats: {
    title: "Confira nossos números",
    subtitle:
      "Somente um robô com solidez e profissionalismo pode proporcionar",
    data: [
      {
        value: "+15",
        description: "Anos de experiência",
      },
      {
        value: "+1k",
        description: "Traders com ganhos consistentes",
      },
      {
        value: "+100",
        description: "Indicadores sendo avaliados por segundo",
      },
    ],
  },

  features: {
    title: "Vantagens",
    subtitle: "Veja quais as principais vantagens dos robôs da Asimov.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.balance,
        title: "Robôs conservadores",
        description:
          "Que vão trazer vida longa aos seus investimentos em renda variável.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Todos os ajustes das estratégias são realizados automaticamente.",
      },
      {
        icon: iconsSet.chip,
        title: "Inteligência Artificial",
        description:
          "Trades realizados com técnicas avançadas de inteligência artificial, igual a grandes fundos internacionais.",
      },
      {
        icon: iconsSet.clock,
        title: "Liberdade",
        description:
          "Ganhe tempo deixando as estratégias operando na plataforma por você sem precisar estar na frente do computador.",
      },
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Asimov",
  },

  testimonials: [
    {
      text: "Estou divulgando o seu robô para todos os meus amigos traders.",
      author: "Humberto Chagas",
      job: "Médico",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Quero parabenizá-lo pelo trabalho desenvolvido e pela seriedade, sempre prezando pelo resultado e satisfação do cliente.",
      author: "Marcelo Machado",
      job: "Advogado",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],
};
